import React from 'react'
import { useHistory } from 'react-router-dom'
import queryString from 'qs'
import i18n from 'translations/i18n'
import { Helmet as ReactHelmet } from 'react-helmet'
import LoaderComponent from 'components/LoaderComponent'

const VisitorLanguag = (WrappedComponent) => (props) => {
  const history = useHistory()
  const [loadingLang, setLoadingLang] = React.useState(true)
  const { lang } = queryString.parse(history.location.search, { ignoreQueryPrefix: true })
  const validateLang = !!lang && ['ar', 'en'].includes(lang) && lang

  const handleVisitorLanguage = () => {
    if (!validateLang) {
      return setLoadingLang(false)
    }
    return i18n.changeLanguage(lang).then(() => {
      setLoadingLang(false)
    })
  }

  React.useEffect(() => {
    handleVisitorLanguage()
  }, [])

  return (
    <>
      <ReactHelmet>
        <html
          lang={validateLang || i18n.language}
          dir={lang === 'ar' ? 'rtl' : 'ltr'}
        />
      </ReactHelmet>
      {loadingLang ? <LoaderComponent /> : <WrappedComponent {...props} />}
    </>
  )
}

export default VisitorLanguag
